import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  QueryList,
  TemplateRef,
  ViewChildren,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgSelectComponent } from '@ng-select/ng-select';
import { finalize, startWith } from 'rxjs/operators';

import { CheckboxComponent } from '@shared/components/checkbox/checkbox.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { OverlayService } from '@shared/services/overlay.service';

import { ScenarioComponent } from '../scenario.component';
import { ScenarioDialogComponent } from './scenario-dialog/scenario-dialog.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, CheckboxComponent, NgSelectComponent],
  selector: 'aux-scenario-manager',
  styles: [],
  templateUrl: './scenario-manager.component.html',
})
export class ScenarioManagerComponent implements AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly overlayService = inject(OverlayService);
  private readonly scenarioPage = inject(ScenarioComponent);

  budgets = [
    {
      header: 'Current Budget',
      row1: 'Vendor Contract: Parexel',
      row2: 'Total Cost: $24,500,00',
      row3: 'Timeline: 40 weeks',
    },
    {
      header: 'Change Order #761123',
      row1: 'Vendor Contract: Parexel',
      row2: 'Total Cost: $26,000,00 (+6.2%)',
      row3: 'Timeline: 45 weeks (+5 weeks)',
    },
  ];
  scenarios = [
    {
      header: 'Enrollment Rate Change',
      row1: 'Total Cost: $27,000,000 (+8%)',
      row2: 'Timeline: 38 weeks (-2 weeks)',
      row3: 'Owner: Adam W. (Sponsor)',
    },
  ];
  @ViewChildren('scenarioTemp') scenarioTemp!: QueryList<TemplateRef<unknown>>;

  ngAfterViewInit(): void {
    this.scenarioTemp.changes
      .pipe(
        startWith(null),
        takeUntilDestroyed(this.destroyRef),
        finalize(() => {
          setTimeout(() => {
            this.scenarioPage.rightSideContainer.next(null);
          }, 0);
        })
      )
      .subscribe(() => {
        setTimeout(() => {
          this.scenarioPage.rightSideContainer.next(this.scenarioTemp.first || null);
        }, 0);
      });
  }

  createScenario() {
    this.overlayService.open({ content: ScenarioDialogComponent });
  }
}
